    export class ClienteProjection {
        Descrizione: string;
        Id: string;
    }
